import { CatAccordionPanel } from '@blocks-react/components/AccordionPanel';
import { PropsWithChildren } from 'react';

import style from '../Footer.module.scss';
import { CatHeading } from '@blocks-react/components/Heading';

interface Props {
  title: string;
}

export function FooterAccordionPanel({
  title,
  children,
}: PropsWithChildren<Props>) {
  return (
    <CatAccordionPanel alignToggleRight={true}>
      <CatHeading
        slot="header"
        level="h6"
        color="knockout"
        aria-label={title}
      >
        {title}
      </CatHeading>
      <ul className={style['footer__list']}>{children}</ul>
    </CatAccordionPanel>
  );
}
